import React from 'react'
import  {BrowserRouter as Router,Route} from 'react-router-dom'
import Join from  './components/Join/Join'
import {Helmet} from "react-helmet"
import Chat from './components/Chat/Chat'

const App = () => {
    return(
    <Router>
        <Route exact path="/" component={Join}/>
        <Route path="/chat" component={Chat}/>
        <Helmet>
                <meta charSet="utf-8" />
                <title>VashChat</title>
                <link rel="canonical" href="chat-app-vash.web.app" />
        </Helmet>
    </Router>
    )
}

export default App